export const PACKAGE_NAME = 'jiraIssueNavigatorActionExportIssues';
export const TEAM_NAME = 'empanada';
